// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"./colors.css\"","breakpoints":"\"./breakpoints.css\"","light":"#E3E3E1","dark":"#111111","large_desktop":"only screen and (min-width: 1201px)","desktop":"only screen and (min-width: 1025px) and (max-width: 1200px)","tablet":"only screen and (min-width: 768px) and (max-width: 1024px)","mobile":"only screen and (max-width: 767px)","small_mobile":"only screen and (max-width: 374px)"};


//////////////////
// WEBPACK FOOTER
// ./style/index.css
// module id = rq4c
// module chunks = 0